<template>
<div class="chapter">
<div class="inner_page">
<a id="p1"></a>
<div class="copyright">
<p class="center ">Copyright 1932 by Harcourt, Inc.</p>
<div class="timebreak "> </div>
<p class="center ">All rights reserved. No part of this publication may be reproduced or transmitted in any form or by any means, electronic or mechanical, including photocopy, recording, or any information storage and retrieval system, without permission in writing from the publisher.</p>
<div class="timebreak "> </div>
<p class="center ">For information about permission to reproduce selections from this book, write to <a href="mailto:trade.permissions@hmhco.com">trade.permissions@hmhco.com</a> or to Permissions, Houghton Mifflin Harcourt Publishing Company, 3 Park Avenue, 19th Floor, New York, New York 10016.</p>
<div class="timebreak "> </div>
<p class="center "><a href="https://hmhbooks.com/" target="_blank">hmhbooks.com</a></p>
<div class="timebreak "> </div>
<p class="center ">Published by arrangement with Editions Gallimard</p>
<div class="timebreak "> </div>
<p class="center ">The Library of Congress has cataloged the print edition as follows:
<br/>Saint-Exupéry, Antoine de, 1900–1944.
<br/>Night flight.
<br/>(A Harvest book)
<br/>Reprint of the translation of Vol de nuit, originally published by Reynal &amp; Hitchcock, New York.
<br/>I. Title.
<br/>PZ3.S137Ni10 [PQ2637.A274] 843'.9'12 73-16016
<br/><span class="smallcaps">ISBN</span> 978-0-15-665605-4</p>
<div class="timebreak "> </div>
<p class="center ">e<span class="smallcaps">ISBN</span> 978-0-547-54279-9<br/>
v5.0620</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// front01.vue?5b9df014